// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Co_m","input":"styles_input__1kwAl"};